import { useGetInstitutionQuery } from "@lending/hooks/queries/useGetInstitutionQuery";

function useLendingApplicationSteps() {
  const { institution } = useGetInstitutionQuery();

  return {
    showLivingArrangementStep: institution.lending_application_steps?.living_arrangement ?? true,
    showEmploymentDetailsStep: institution.lending_application_steps?.employment_details ?? true,
  };
}

export { useLendingApplicationSteps };
